import mixpanel from "mixpanel-browser";
import { mixPanelEvents } from "src/StoreGlobal/mixPanelEvents";

export { mixPanelEvents };

export const trackEvent = (eventName, properties = {}) => {
  mixpanel.track(eventName, { ...properties, 'AIMHI Version': 1 });
};

export const identifyUser = (userId, properties = {}) => {
  mixpanel.identify(userId);
  mixpanel.people.unset([
    "$email",
    "$name",
    "Department",
    "username",
    "phone",
    "Position"
  ]);
  mixpanel.people.set(properties);
};

export const resetUser = () => {
  mixpanel.reset();
};

export default mixpanel;
